import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IStyledProps {
  $bgColor?: string;
  $pointColor?: string;
  $emphasisTextColor?: string;
}

export const CouponItem2 = styled.div<IStyledProps>`
  position: relative;
  width: 100%;
  height: 60px;
  text-align: left;
  ${mixin.flex({ align: 'center', justify: 'flex-start' })}
  background: #000;

  &.disabled {
    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(255, 255, 255, 0.6);
      z-index: 1;
    }
  }

  ${({ $bgColor, $pointColor, $emphasisTextColor }) =>
    $bgColor &&
    css`
      background: ${$pointColor};

      .text-wrap {
        &:before,
        &:after {
          background: ${$bgColor} !important;
        }

        .title {
          color: ${$emphasisTextColor} !important;
        }

        .desc {
          color: ${$emphasisTextColor} !important;
        }
      }

      .btn svg g {
        fill: ${$emphasisTextColor};
      }
    `}

  &.bg-type-gray {
    background: #333;

    &.disabled:after {
      background: rgba(0, 0, 0, 0.6);
    }

    .text-wrap {
      &:before,
      &:after {
        background: #000;
      }
    }

    /* .btn {
      &:before {
        background: #777;
        opacity: 0.2;
      }
    } */
  }

  .text-wrap {
    width: calc(100% - 53px);
    padding: 13px 20px;

    &:before,
    &:after {
      position: absolute;
      right: 48px;
      content: '';
      display: block;
      width: 9px;
      height: 9px;
      border-radius: 50%;
      background: #fff;
      z-index: 2;
    }

    &:before {
      top: -4.5px;
    }

    &:after {
      bottom: -4.5px;
    }

    .title {
      font-size: 15px;
      line-height: 130%;
      font-weight: 500;
      ${mixin.ellipsis(1)};
      color: #fff;

      + .desc {
        margin-top: 2px;
      }
    }

    .desc {
      font-size: 11px;
      line-height: 130%;
      ${mixin.ellipsis(1)};
      color: #ccc;

      span {
        font-weight: 700;
      }
    }
  }

  .btn {
    position: relative;
    width: 53px;
    height: 100%;
    flex-direction: column;

    svg {
      width: 16px;
      height: 19px;
    }

    .text {
      font-size: 10px;
      line-height: 14px;
      color: #fff;
      margin-top: 3.5px;

      em {
        font-size: 11px;
      }
    }

    &:before {
      content: '';
      display: block;
      width: 1px;
      height: 23px;
      background: rgba(255, 255, 255, 0.2);
      position: absolute;
      top: 50%;
      left: 0px;
      transform: translateY(-50%);
    }

    &:disabled {
      background: transparent !important;

      /* svg g {
        fill: #555;
      }

      .text {
        color: #555;
      } */
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    height: ${mixin.pxToVw('60')};

    .text-wrap {
      width: calc(100% - ${mixin.pxToVw('53')});
      padding: ${mixin.pxToVw('13 20')};

      &:before,
      &:after {
        right: ${mixin.pxToVw('48')};
        width: ${mixin.pxToVw('9')};
        height: ${mixin.pxToVw('9')};
      }

      &:before {
        top: ${mixin.pxToVw('-4.5')};
      }

      &:after {
        bottom: ${mixin.pxToVw('-4.5')};
      }

      .title {
        font-size: ${mixin.pxToVw('15')};

        + .desc {
          margin-top: ${mixin.pxToVw('2')};
        }
      }

      .desc {
        font-size: ${mixin.pxToVw('11')};
      }
    }

    .btn {
      width: ${mixin.pxToVw('53')};

      svg {
        width: ${mixin.pxToVw('16')};
        height: ${mixin.pxToVw('19')};
      }

      .text {
        font-size: ${mixin.pxToVw('10')};
        line-height: ${mixin.pxToVw('14')};
        margin-top: ${mixin.pxToVw('3.5')};

        em {
          font-size: ${mixin.pxToVw('11')};
        }
      }

      &:before {
        height: ${mixin.pxToVw('23')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    width: 401px;
    height: 84px;

    .text-wrap {
      width: calc(100% - 76px);

      &:before,
      &:after {
        right: 71.5px;
      }

      .title {
        font-size: 16px;

        + .desc {
          margin-top: 8px;
        }
      }

      .desc {
        font-size: 13px;
      }
    }

    .btn {
      width: 76px;

      &:before {
        height: 43px;
      }
    }
  }
`;
